import { useContext } from 'react'

import { CMSModalContext } from '@Globals/CMS/Modal/Context'

export const useCMSModalOpen = () => {
  const [, openModal] = useContext(CMSModalContext)
  return openModal
}
